import React from 'react';
import './Home.css';
import Slider from './Slider';
export default function Home() {
    return (
        <>
           
            <div className='bgh col-12 '>
                <Slider />
                <img className="home-img" src="https://res.cloudinary.com/dluyslfrm/image/upload/v1679226139/About_Us_4_rwdkwb.png"/>
              
            </div>
            


        </>


    );
}
